import moment from 'moment/moment';

export const MAX_FILE_SIZE = 5 * 1000 * 1000; // 5 MB in bytes
export const MAX_EML_FILE_SIZE = 20 * 1000 * 1000; // 5 MB in bytes
export const CLIENT_EMAIL_ATTACHMENT_TYPE = 'CLIENT_EMAIL';
export const EMAIL_ATTACHMENT_TYPE = 'EMAIL';
export const WAREHOUSE_ATTACHMENT_TYPE = 'WAREHOUSE';

export const USER_TYPES = {
  REGULAR: 'REGULAR',
  WAREHOUSE: 'WAREHOUSE',
} as const;

export const UserTypesMapping = {
  REGULAR: 'ERP System',
  WAREHOUSE: 'Warehouse',
} as const;

export const dateFormatter = (date: Date, starrOrEnd?: 'start' | 'end') => {
  if (!date) return undefined;
  if (starrOrEnd === 'end') {
    return moment(date.toISOString()).endOf('day').format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
  }
  return moment(date.toISOString()).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
};
